import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useReduxSelector } from "../redux/hooks";

interface AppLayoutProps {
    children: ReactNode;
    requireAuth?: boolean;
}

export function AppLayout({ children, requireAuth = true }: AppLayoutProps) {
    const { isSignedIn } = useReduxSelector((state) => state.user);
    const navigate = useNavigate();

    if (requireAuth && !isSignedIn) {
        return (
            <div className="flex flex-col justify-center items-center m-auto w-full h-screen">
                <p>Please sign in to continue</p>
                <button
                    className="px-8 py-3 mt-4 text-sm text-white rounded-3xl shadow-2xl bg-primary-300"
                    onClick={() => navigate("/signin")}
                >
                    Sign In
                </button>
            </div>
        );
    }

    return (
        <div className="p-0">
            {children}
        </div>
    );
} 